export default "__VITE_ASSET__BBMYvUGM__"